import { FC, useState } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import styled from "styled-components/macro";

interface Props {
  hoverColor?: string;
  circle?: boolean;
}

const Wrapper = styled(Link)<Props>`
  width: ${(props) => (props.circle ? "240px" : "300px")};
  height: ${(props) => (props.circle ? "240px" : "300px")};
  padding: ${(props) => (props.circle ? "30px" : "10px")};
  background-color: #d8d5fbff;
  border-radius: ${(props) => (props.circle ? "50%" : "32px")};
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateY(0);
  z-index: 1000;
  position: relative;

  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(16px);

  .content {
    position: absolute;
    width: ${(props) => (props.circle ? "240px" : "300px")};
  }
  :hover {
    background-color: ${(props) => props.hoverColor};
    background: ${(props) => props.hoverColor};
    cursor: pointer;
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(29, 91, 206, 0.15);
    h2,
    p {
      color: white;
      transition: background-color 0.5s ease;
      transition: background 0.5s ease;
    }
  }
`;

const Title = styled.h2`
  color: #1d5cce;
  font-family: "DM Serif Display", serif;
  font-size: 40px;
  font-weight: 400;
  letter-spacing: 1px;
  display: flex;
  padding: 0px 0px 0px 24px;
  margin: 0px;
  transition: background-color 0.5s ease;
`;
const RadarWrapper = styled.div`
  width: 30vw;
  display: inline-block;
  transition: background-color 0.5s ease;
  @media screen and (max-width: 1000px) {
    display: none;
  }
`;
const RadarDescription = styled.p<Props>`
  color: #1d5cce;
  margin: 0px;
  font-size: 1rem;
  letter-spacing: 1px;
  font-family: "DM Sans", serif;
  padding: ${(props) =>
    props.circle ? "10px 0px 0px 24px;" : "10px 0px 10px 24px"};
  line-height: 1.5;
  transition: background-color 0.5s ease;
`;

const RadarLink = styled.span<Props>`
  position: absolute;
  margin-top: 10px;
  right: ${(props) => (props.circle ? "10%" : "5%")};
  color: white;
  font-weight: 200;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  font-family: poppins, sans-serif;
`;

const Yellowcircle = styled.span`
  background-color: #f7d54a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-left: 4px;
  position: relative;
`;

const size = 350;
const outterRadius = size / 2;
const middleRadius = (outterRadius * 2) / 3;
export type CirclePositionType = "top" | "bottom" | "left" | "right";
interface PortfolioCardProps {
  title: string;
  hoverColor: string;
  description: string;
  link: string;
  linkText: string;
  circle?: boolean;
  circlePosition?: CirclePositionType;
}

const getCirclePosition = (position: CirclePositionType) => {
  switch (position) {
    case "top":
      return "translate(150 -20)";
    case "bottom":
      return "translate(150 330)";
    case "left":
      return "translate(-30, 150)";
    case "right":
      return "translate(320, 150)";
    default:
      return "";
  }
};

const PortfolioCard: FC<PortfolioCardProps> = ({
  title,
  description,
  linkText,
  link,
  hoverColor,
  circle = false,
  circlePosition = "top",
}) => {
  const [hovered, setHovered] = useState(false);
  return (
    <Wrapper
      circle={circle}
      hoverColor={hoverColor}
      to={link}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="content">
        <Title>{title}</Title>
        <RadarDescription circle={circle}>{description}</RadarDescription>

        <RadarLink circle={circle}>
          {linkText.toUpperCase()}
          <Yellowcircle>
            <ArrowForwardIcon />
          </Yellowcircle>
        </RadarLink>
      </div>

      <RadarWrapper>
        <svg
          width={300}
          height={300}
          viewBox="0 0 300 300"
          style={{ overflow: "visible" }}
        >
          <g transform={getCirclePosition(circlePosition)}>
            {/* 2 main rings */}
            <circle
              cx={0}
              cy={0}
              r={outterRadius}
              fill="#ffffff"
              stroke="lightgrey"
              opacity={0.3}
            />
            <circle
              cx={0}
              cy={0}
              r={middleRadius}
              fill="#ffffff"
              opacity={0.3}
            />
          </g>
        </svg>
      </RadarWrapper>
      {/* {title === "Projects" && hovered && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(30, 30, 30, 0.7)",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1.5rem",
            zIndex: 2000,
            pointerEvents: "none",
            fontFamily: "Poppins, sans-serif",
            transition: "0.5s ease",
          }}
        >
          Coming Soon
        </div>
      )} */}
    </Wrapper>
  );
};

export default PortfolioCard;
